<span class="badge" [style.color]="color" [class.is-outline]="outline">
    <span class="background" [style.backgroundColor]="color"></span>
    <ng-content></ng-content>
</span>
